export const GET_OWNERSHIP_TYPES = '[Ownership Type Action] Get ownership types';
export const CONFIRMED_GET_OWNERSHIP_TYPES = '[Ownership Type Action] Confirmed Get ownership types';
